import {
  detachLayoutProps,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSImage,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useAdvocate, useMemberProfile } from "../../../query/users/queries";
import styles from "./WSVirtualAssistant.module.scss";

interface WSVirtualAssistantProps extends WSElementProps {
  message: string;
}

export const WSVirtualAssistant: React.FC<WSVirtualAssistantProps> = ({
  message,
  ...otherProps
}) => {
  const userId = useUserId();
  const qMember = useMemberProfile(userId);
  const qAdvocate = useAdvocate(qMember.data?.advocateId as string);
  const { layoutProps } = detachLayoutProps(otherProps);
  return (
    <>
      <WSScreen.Mobile>
        <WSFlexBox wrap="nowrap" {...layoutProps} mb="3XL">
          <WSImage
            src={qAdvocate.data?.photoUrl as string}
            placeholder=""
            className={styles.photo}
            mr="M"
          />
          <WSElement className={styles.card}>
            <WSText>{message}</WSText>
          </WSElement>
        </WSFlexBox>
      </WSScreen.Mobile>
      <WSScreen.TabletAndDesktop>
        <WSFlexBox.CenterY
          wrap="nowrap"
          className={styles.card}
          {...layoutProps}
        >
          <WSImage
            src={qAdvocate.data?.photoUrl as string}
            placeholder=""
            className={styles.photo}
            mr="XL"
          />
          <WSElement>
            <WSText>{message}</WSText>
          </WSElement>
        </WSFlexBox.CenterY>
      </WSScreen.TabletAndDesktop>
    </>
  );
};
